import React from "react";
import Button from "../Button";
import SimpleModal from "./SimpleModal";
import { Title, SubLabel } from "./styles";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onConfigure: () => void;
}

const PersuasionModalProfile: React.FC<Props> = ({
  isOpen,
  toggle,
  onConfigure,
}) => {
  const handleRemindLater = () => {
    const today = new Date();
    localStorage.setItem("mfa_persuasion_date", today.toISOString());
    toggle();
  };

  return (
    <SimpleModal isOpen={isOpen} onClose={toggle} title="" size="md">
      <div style={{ padding: "24px" }} className="modal-content-responsive">
        <Title>Mejora la seguridad de tu cuenta</Title>

        <div style={{ marginTop: "24px" }}>
          <SubLabel>
            Habilita la autenticación de dos factores para agregar una capa
            adicional de seguridad a tu cuenta.
          </SubLabel>

          <div
            style={{
              backgroundColor: "#eff6ff",
              padding: "16px",
              borderRadius: "8px",
              marginTop: "16px",
              border: "1px solid #3b82f6",
            }}
          >
            <h5
              style={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "12px",
                color: "#1e40af",
              }}
            >
              🔒 Beneficios de la autenticación de dos factores:
            </h5>
            <ul style={{ paddingLeft: "20px", color: "#1e40af" }}>
              <li>Protección adicional contra accesos no autorizados</li>
              <li>Seguridad incluso si tu contraseña es comprometida</li>
              <li>Cumplimiento con estándares de seguridad corporativos</li>
            </ul>
          </div>

          <SubLabel style={{ marginTop: "16px" }}>
            La configuración solo toma unos minutos y protegerá tu cuenta de
            manera significativa.
          </SubLabel>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "12px",
          padding: "0 24px 24px",
        }}
        className="modal-footer-responsive"
      >
        <Button
          type="button"
          options={{ skin: "secondary", size: "md", type: "filled" }}
          onClick={handleRemindLater}
        >
          Recordarme en 30 días
        </Button>
        <Button
          type="button"
          options={{ skin: "primary", size: "md", type: "filled" }}
          onClick={onConfigure}
        >
          Configurar ahora
        </Button>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .modal-content-responsive {
            padding: 16px !important;
          }
          .modal-footer-responsive {
            flex-direction: column !important;
            padding: 0 16px 16px !important;
          }
          .modal-footer-responsive button {
            width: 100%;
          }
        }
      `}</style>
    </SimpleModal>
  );
};

export default PersuasionModalProfile;
